import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe, BROWSER_LANGUAGE_MAP, Language, LANGUAGE_BY_DEFAULT } from '../../../common';
import { AppFacade, PublicTrackingItemFacade } from '../../../store';
import { ProjectorName } from '../../projection';
import { Router } from '@angular/router';

@Component({
  selector: 'public-tracking-header',
  templateUrl: './public-tracking-header.component.html',
  styleUrls: ['./public-tracking-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class PublicTrackingHeaderComponent implements OnInit {
  languageControl: FormControl<Language>;
  subscriptions: Subscription[] = [];
  projectorName = ProjectorName;
  private noHomePageRoutes = ['/erp-tracking'];

  constructor(
    private appFacade: AppFacade,
    private router: Router,
    public publicTrackingItemFacade: PublicTrackingItemFacade,
  ) {}

  ngOnInit(): void {
    this.setLanguageFromBrowserSettings();
    this.subscriptions.push(
      this.languageControl.valueChanges.subscribe((language: Language) => {
        this.appFacade.changeLang(language);
      }),
    );
  }

  get noHomePage(): boolean {
    return this.noHomePageRoutes.some((r: string) => this.router.url.includes(r));
  }

  clearSearchedData(): void {
    this.publicTrackingItemFacade.clearState();
  }

  setLanguageFromBrowserSettings(): void {
    const browserLanguage: string = navigator.language?.slice(0, 2);
    const defaultLanguage: Language = BROWSER_LANGUAGE_MAP.get(browserLanguage) || LANGUAGE_BY_DEFAULT;
    this.appFacade.changeLang(defaultLanguage);
    this.languageControl = new FormControl<Language>(defaultLanguage);
  }
}
